import BlockedChat from './BlockedChat/index.vue';
import blockedChatMixin from './BlockedChat/mixin';

export default {
  components: {
    BlockedChat,
  },
  mixins: [blockedChatMixin],
  computed: {
    // Chatwoot 4.10 (#12973) lets API inboxes keep replying outside their reply window, like
    // WhatsApp. Zimobi keeps 4.8's behaviour: outside the window an API conversation is note-only,
    // instead of showing BlockedChat's WhatsApp template notice. ReplyBox reads this in place of
    // upstream's `isAWhatsAppChannel || isAPIInbox`.
    canReplyOutsideWindow() {
      return this.isAWhatsAppChannel;
    },
    isChatBlocked() {
      return (
        !this.isOnPrivateNote &&
        (!this.isConversationOpen ||
          this.isWhatsappRestricted ||
          this.isWidgetInboxConversationAndCurrentContactOffline)
      );
    },
    isBottomPanelAble() {
      return (
        this.isOnPrivateNote ||
        (this.isConversationOpen &&
          !this.isWhatsappRestricted &&
          !this.isWidgetInboxConversationAndCurrentContactOffline)
      );
    },
  },
  watch: {
    inbox: {
      immediate: true,
      handler(inbox) {
        if (!inbox.id) this.fetchConversationInbox(this.inboxId);
      },
    },
  },
  methods: {
    async fetchConversationInbox(inboxId) {
      if (!inboxId || this.inbox.id) return;

      try {
        await this.$store.dispatch('inboxes/getConversationInbox', {
          conversationId: this.currentChat.id,
          inboxId,
        });
      } catch {
        // The reply box keeps its existing text-only fallback when inbox metadata cannot be loaded.
      }
    },
  },
};
